module.exports = __webpack_public_path__ + "fonts/fa-brands-400.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-brands-400.eot
// module id = 11
// module chunks = 0